// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"d5daec0cfdca52e1cdc6","678":"6458665c24b9e474e5e9","883":"2a143fa9dd6d20b2ef09"}[chunkId] + ".js";
};